import { OVVRequests } from "../api/OVVRequests";

export const getRequests = (id) => {
  return OVVRequests.getRequests(id).then(response => response);
};

export const getUserOVVRequestProject = (id) => {
  return OVVRequests.getUserRequestProject(id).then(response => response);
};
export const addRequest = (data) => {
  return OVVRequests.addRequest(data).then(response => response);
};

export const addReportAttachment = (data) => {
  return OVVRequests.addReportAttachment(data).then(response => response);
};

export const generatePDFHistory = (data) => {
  return OVVRequests.generatePDFHistory(data).then(response => response);
};

export const issueOpinion = (data) => {
  return OVVRequests.issueOpinion(data).then(response => response);
};

export const getAnswers = (id) => {
  return OVVRequests.answers(id).then(response => response);
};
